import React, { useState } from "react";
import { usePageMeta } from "@/lib/usePageMeta";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useI18n } from "@/contexts/I18nContext";

export default function ForgotPassword() {
  const { t } = useI18n();
  usePageMeta({ title: t("forgot_title"), noindex: true });
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      // Always show the same confirmation regardless of outcome - Supabase
      // doesn't reveal whether the email exists, avoiding account enumeration.
      await supabase.auth.resetPasswordForEmail(email.trim(), {
        redirectTo: `${window.location.origin}/reset-password`,
      });
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="max-w-sm mx-auto py-16 px-4 sm:px-0 text-center animate-in fade-in duration-500">
      <h1 className="text-2xl font-serif-en mb-2">{t("forgot_title")}</h1>
      {sent ? (
        <p className="text-sm text-muted-foreground mt-4" data-testid="forgot-sent-msg">{t("forgot_sent")}</p>
      ) : (
        <>
          <p className="text-sm text-muted-foreground mb-6">{t("forgot_subtitle")}</p>
          <form onSubmit={submit} className="space-y-4 text-left">
            <div>
              <label htmlFor="forgot-email" className="text-sm text-muted-foreground">{t("login_email")}</label>
              <Input id="forgot-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required
                autoComplete="email" data-testid="forgot-email-input" />
            </div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-btn">
              {loading ? "…" : t("forgot_send")}
            </Button>
          </form>
        </>
      )}
      <p className="text-sm text-center text-muted-foreground mt-6">
        <Link to="/login" className="text-primary underline underline-offset-4" data-testid="forgot-login-link">{t("back_to_login")}</Link>
      </p>
    </div>
  );
}
